import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f3594d98"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  key: 0,
  class: "living-btn"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "right one-live"
};
const _hoisted_5 = {
  class: "live-info"
};
const _hoisted_6 = {
  class: "live-name text-overflow"
};
const _hoisted_7 = {
  class: "teacher-school"
};
const _hoisted_8 = {
  key: 0,
  class: "split"
};
const _hoisted_9 = {
  class: "time"
};
const _hoisted_10 = {
  key: 1,
  class: "status-start"
};
const _hoisted_11 = {
  key: 1,
  class: "right"
};
const _hoisted_12 = {
  class: "live-name text-overflow"
};
const _hoisted_13 = {
  class: "teacher-school"
};
const _hoisted_14 = {
  key: 0,
  class: "split"
};
const _hoisted_15 = {
  class: "time"
};
const _hoisted_16 = {
  key: 1,
  class: "status-start"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["live-card", {
      'one-live-card': $props.liveCount === 1
    }])
  }, [_createElementVNode("div", _hoisted_1, [$props.liveData.live_status == '2' ? (_openBlock(), _createElementBlock("span", _hoisted_2, "直播中")) : _createCommentVNode("", true), _createElementVNode("img", {
    src: $props.liveData.live_cover_url || require('../../../assets/images/video_cover.jpg'),
    alt: ""
  }, null, 8, _hoisted_3)]), $props.liveCount === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_6, _toDisplayString($props.liveData.live_name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString($props.liveData.lecturer), 1), $props.liveData.lecturer && $props.liveData.school_name ? (_openBlock(), _createElementBlock("span", _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($props.liveData.school_name), 1)])]), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$utils.formatDate($props.liveData.start_time, 'MM月DD日 HH:mm')) + " - " + _toDisplayString(_ctx.$utils.formatDate($props.liveData.end_time, 'MM月DD日 HH:mm')), 1)]), $props.liveData.live_status == '2' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "status-watch",
    onClick: _cache[0] || (_cache[0] = $event => $options.goDetail($props.liveData.id))
  }, "观看直播")) : _createCommentVNode("", true), $props.liveData.live_status !== '2' ? (_openBlock(), _createElementBlock("div", _hoisted_10, "未开始")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString($props.liveData.live_name), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString($props.liveData.lecturer), 1), $props.liveData.lecturer && $props.liveData.school_name ? (_openBlock(), _createElementBlock("span", _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($props.liveData.school_name), 1)]), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$utils.formatDate($props.liveData.start_time, 'MM月DD日 HH:mm')) + " - " + _toDisplayString(_ctx.$utils.formatDate($props.liveData.end_time, 'MM月DD日 HH:mm')), 1), $props.liveData.live_status == '2' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "status-watch",
    onClick: _cache[1] || (_cache[1] = $event => $options.goDetail($props.liveData.id))
  }, "观看直播")) : _createCommentVNode("", true), $props.liveData.live_status !== '2' ? (_openBlock(), _createElementBlock("div", _hoisted_16, "未开始")) : _createCommentVNode("", true)]))], 2);
}